import { useCallback, useEffect } from 'react'
import { IOpenPanel } from '../../../../interfaces/base/IPanel'
import { IComboBox, IComboBoxOption, Panel, PanelType, TextField, Toggle } from '@fluentui/react'
import { MessageBarResponse } from '../../../../components/MessageBar/MessageBarResponse'
import { ProgressBarLoading } from '../../../../components/ProgressBarLoading/ProgressBarLoading'
import { UseRosterActualizar } from './UseRosterActualizar'
import { IRoster } from '../../../../interfaces/IRoster'
import { PanelHeader } from '../../../../components/PanelHeader/PanelHeader'
import { PanelFooter } from '../../../../components/PanelFooter/PanelFooter'
import { ComboBoxBase } from '../../../../components/comboBoxComponent/ComboBoxBase';
import { UseComboGuardiaProgramacion } from '../../../../hooks/combos/UseComboGuardiaProgramacion'
import React from 'react'

export interface IPanelRosterEditar extends IOpenPanel {
   rosterData: IRoster
}

const PanelRosterActualizar = (props: IPanelRosterEditar) => {
   const { command, setCommand, putEditarRoster, loading, setLoading, reset, mensaje, setMensaje, status, disableForm, buttonSalir } = UseRosterActualizar(props);
   const { dataComboGuardiaProgramacion, onClickComboGuardiaProgramacion, _onkeyUpSearchGuardiaProgramacion, comboBoxRefGuardiaProgramacion } = UseComboGuardiaProgramacion(props.isOpen);

   const [turnoDiaChecked, setTurnoDiaChecked] = React.useState(props.rosterData?.dia);
   const [turnoNocheChecked, setTurnoNocheChecked] = React.useState(props.rosterData?.noche);

   const onChangeCombo = (event: React.FormEvent<IComboBox>, option?: IComboBoxOption, type?: string) => {
      if (event != undefined) {
         if (option != undefined) {
            switch (type) {
               case 'guardia':
                  setCommand({
                     ...command,
                     guardiaProgramacionId: option.key.toString(),
                  })
                  break;
               default:
                  break;
            }
         }
      }
   }

   const _onChangeToggle = (
      type: string,
      ev: React.MouseEvent<HTMLElement>,
      checked?: boolean
   ) => {
      if (checked != undefined) {
         switch (type) {
            case "dia":
               setCommand({
                  ...command,
                  dia: checked,
               });
               setTurnoDiaChecked(checked);
               break;
            case "noche":
               setCommand({
                  ...command,
                  noche: checked,
               });
               setTurnoNocheChecked(checked);
               break;
            default:
               break;
         }
      }
   };

   const onReset = () => {
      setLoading(false);
      setMensaje("");
   }

   const onRenderHeader = useCallback(
      () => (
         <>
            <PanelHeader
               nameIconHeader="pdate"
               textHeader={`Rosters`}
               subTextHeader={`Actualizar roster`}
            />
         </>
      ), []
   );

   const onRenderFooter = useCallback(
      () => (
         <>
            <PanelFooter
               texto="Actualizar"
               // texto2={"Salir"}
               disableButton={disableForm}
               onClick={putEditarRoster}
               onDismiss={reset}
            />
         </>
      ), [command, disableForm]
   );

   const onRenderFooter2 = useCallback(
      () => (
         <>
            <PanelFooter
               texto="Salir"
               // texto2={"Salir"}
               // disableButton={disableForm}
               onClick={reset}
               oneButton={true}
            />
         </>
      ), [command, disableForm]
   );

   useEffect(() => {
      setCommand({
         ...props.rosterData,
         dia: props.rosterData?.dia,
         noche: props.rosterData?.noche,
      })
   }, [props.rosterData])

   return (
      <Panel
         type={PanelType.medium}
         onRenderHeader={onRenderHeader}
         onRenderFooter={(!loading && mensaje == "") ? onRenderFooter : buttonSalir ? onRenderFooter2 : undefined}
         isFooterAtBottom
         isOpen={props.isOpen}
         onDismiss={reset}
      >
         <div className="ms-Grid" dir="ltr">
            {mensaje &&
               <MessageBarResponse
                  objetoResponse={{ codigo: status, mensaje: mensaje }}
                  close={true}
               // function={onReset}
               />
            }
            {loading &&
               <ProgressBarLoading></ProgressBarLoading>}
            {!loading && !mensaje &&
               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gridGap: "10px" }}>
                  <TextField
                     type="text"
                     label="Código de Roster:"
                     placeholder="Ingrese código"
                     autoComplete="off"
                     value={command.codigo}
                     onChange={(event, newValue) => {
                        if (newValue != null) {
                           setCommand({ ...command, codigo: newValue })
                        }
                     }}
                  />
                  <TextField
                     type="number"
                     label="Días laborables:"
                     placeholder="Ingrese cantidad de días"
                     autoComplete="off"
                     value={command.diasLaborables || undefined}
                     onChange={(event, newValue) => {
                        if (newValue != null) {
                           setCommand({ ...command, diasLaborables: newValue })
                        }
                     }}
                  />
                  <TextField
                     type="number"
                     label="Días de descanso:"
                     placeholder="Ingrese cantidad de días"
                     autoComplete="off"
                     value={command.diasDescanso || undefined}
                     onChange={(event, newValue) => {
                        if (newValue != null) {
                           setCommand({ ...command, diasDescanso: newValue })
                        }
                     }}
                  />
                  <ComboBoxBase
                     title="Guardia:"
                     componentRef={comboBoxRefGuardiaProgramacion}
                     KeyUp={_onkeyUpSearchGuardiaProgramacion}
                     onClick={onClickComboGuardiaProgramacion}
                     selectedKey={command.guardiaProgramacionId}
                     options={dataComboGuardiaProgramacion}
                     onChange={(e: React.FormEvent<IComboBox>, option) => {
                        onChangeCombo(e, option, "guardia");
                     }}
                     description={true}
                  />
                  <Toggle
                     label="Turno Día"
                     onText="Si"
                     offText="No"
                     onChange={(e, v) => _onChangeToggle("dia", e, v)}
                     checked={turnoDiaChecked}
                     defaultChecked={props.rosterData.dia}
                  />
                  <Toggle
                     label="Turno Noche"
                     onText="Si"
                     offText="No"
                     onChange={(e, v) => _onChangeToggle("noche", e, v)}
                     checked={turnoNocheChecked}
                     defaultChecked={props.rosterData.noche}
                  />
               </div>}
         </div>
      </Panel>
   )
}

export { PanelRosterActualizar }